const tooltipTailleCopro = `
    <div>
        Il s’agit du nombre de copropriétaires souhaités pour cet espace. Celui-ci sera amené à évoluer en fonction du
        déroulé de la programmation et de la volonté des membres du groupe.
    </div>
    <div>
        Ce nombre détermine le prix de la part individuelle pour cet espace. Plus il y a de copropriétaires, plus le prix
        de la part individuelle sera faible.
    </div>
    <div>
        L’administrateur du groupe est la personne référente pour modifier ce paramètre.
    </div>
`

const tooltipAtelier = `
    <div>
        L’atelier de programmation est un outil de sondage ludique et collaboratif. Il nous permet de vous consulter pour
        participer à la définition des projets individuels et collectifs. Ils pourront concerner votre appartement, les
        espaces partagés ou la résidence.
    </div>
    <div>
        Ainsi, vous pourrez nous indiquer plus précisément vos envies concernant par exemple le revêtement de sol de
        votre appartement ou l’équipement de salle de bain, tout comme il pourra vous permettre d’arbitrer par exemple
        du niveau de finition d’un espace en copropriété auquel vous êtes inscrit.
    </div>
    <div>
        Vous serez notifié lors de l’ouverture des ateliers. Ceux-ci sont ouverts pendant une période bien définie, alors
        restez vigilant !
    </div>
    <div>
        Si vous souhaitez nous soumettre une thématique d’atelier de programmation, remplissez le formulaire prévu à
        cet effet en cliquant sur le bouton « créer ».
    </div>
`

export { tooltipTailleCopro, tooltipAtelier }
